import { render, staticRenderFns } from "./personal-rewards-pop.vue?vue&type=template&id=002dd454&scoped=true&"
import script from "./personal-rewards-pop.vue?vue&type=script&lang=js&"
export * from "./personal-rewards-pop.vue?vue&type=script&lang=js&"
import style0 from "./personal-rewards-pop.vue?vue&type=style&index=0&id=002dd454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002dd454",
  null
  
)

export default component.exports